import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import Navigation from "../components/Navigation";
import Footer from "../components/Footer";
import { ProfileUpdateForm, PasswordChangeForm } from "../components/account";
import "../assets/css/AccountSettings.css";

const AccountSettings = (props) => {
    const history = useHistory();
    const { translate } = useSelector((state) => state.general);

    // Redirect if not logged in
    useEffect(() => {
        if (!localStorage.getItem("StadGemeenteToken")) {
            history.push("/");
        }
    }, [history]);

    return (
        <div className="account-settings-page">
            <Navigation type="municipality" />
            <div className="account-settings-container">
                <h1>{translate("account_settings") || "Account beheren"}</h1>
                <p className="subtitle">{translate("account_settings_subtitle") || "Beheer uw persoonlijke gegevens en beveiligingsinstellingen"}</p>
                <div className="settings-sections">
                    <ProfileUpdateForm createNotification={props.createNotification} />
                    <PasswordChangeForm createNotification={props.createNotification} />
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default AccountSettings;
